module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.5.3-118.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.5.3.md
// module id = 533
// module chunks = 279